import EmailSubscriptionService from '@99designs/common/utils/platform/emailSubscriptionService';
import { scrollToElement } from 'common/utils/scroll';

class EmailCaptureFormDeprecated {
    constructor(container, config) {
        this.container = container;
        this.config = config;
        this.service = new EmailSubscriptionService();

        this.container.addEventListener('submit', this.handleSubmit.bind(this));
    }

    handleSubmit(e) {
        e.preventDefault();

        const form = e.target;
        const fieldData = this.getFieldData(form);
        const { acquisitionSource } = this.config;
        const { email, ...customData } = fieldData;

        this.setProcessingState(form);

        if (email) {
            this.service
                .subscribe({
                    email: email,
                    acquisitionSource: acquisitionSource,
                    customData: customData,
                    subscribeToMarketing: true,
                })
                .then(() => {
                    // Hide form
                    this.container.querySelector('[data-form]').setAttribute('data-hidden', true);

                    // Show form success message
                    this.container
                        .querySelector('[data-form-success]')
                        .removeAttribute('data-hidden');

                    this.unsetProcessingState(form);

                    scrollToElement(this.container, 30, 0);
                })
                .catch(() => {
                    this.unsetProcessingState(form);
                });
        }
    }

    getFieldData(form) {
        const result = {};

        for (var i = 0; i < form.elements.length; i++) {
            const element = form.elements.item(i);
            const type = element.getAttribute('type');
            const name = element.getAttribute('name');

            if (!name) {
                continue;
            }

            const match = name.match(this.config.fieldMatchRegexp);

            if (match && match[1]) {
                // This first condition checks if the form input is an array in order to process multiple check boxes
                if (match.input.slice(-2) === '[]') {
                    if (element.checked) {
                        result[match[1]] = result[match[1]]
                            ? result[match[1]] + ', ' + element.value
                            : element.value;
                    }
                } else if (type === 'checkbox') {
                    result[match[1]] = element.checked ? '1' : '0';
                } else {
                    result[match[1]] = element.value;
                }
            }
        }

        return result;
    }

    setProcessingState(form) {
        const fields = form.querySelectorAll('input, textarea, .select');
        const submitButton = form.querySelector('button[type="submit"]');

        submitButton.setAttribute('data-disabled', true);
        submitButton.disabled = true;
        submitButton.classList.add('button--loading');

        for (let field of fields) {
            field.setAttribute('data-disabled', true);
            field.disabled = true;

            if (field.querySelector('select')) {
                const select = field.querySelector('select');

                select.setAttribute('data-disabled', true);
                select.disabled = true;
            }
        }
    }

    unsetProcessingState(form) {
        const fields = form.querySelectorAll('input, textarea, .select');
        const submitButton = form.querySelector('button[type="submit"]');

        submitButton.removeAttribute('data-disabled');
        submitButton.disabled = false;
        submitButton.classList.remove('button--loading');

        for (let field of fields) {
            field.removeAttribute('data-disabled');
            field.disabled = false;

            if (field.querySelector('select')) {
                const select = field.querySelector('select');

                select.removeAttribute('data-disabled');
                field.disabled = false;
            }
        }
    }
}

export default EmailCaptureFormDeprecated;
